import React, { useState, useEffect } from 'react';
import { ChevronLeft, ChevronRight, ArrowUpRight } from 'lucide-react';

const HeroSection = ({ overline, title, description, buttonText, hideTyping = false, contentMaxWidth, typingWords, staticTitle, typingColor, overlay }) => {
  const [currentHeroSlide, setCurrentHeroSlide] = useState(0);
  const [typedText, setTypedText] = useState("");
  const [typingIndex, setTypingIndex] = useState(0);
  const [charIndex, setCharIndex] = useState(0);
  const [isDeleting, setIsDeleting] = useState(false);

  const heroImages = [
    '/projectbim/img/hero/banner1.png',
    '/projectbim/img/hero/banner2.png',
    '/projectbim/img/hero/banner3.png'
  ];

  const wordsToType = typingWords || ["Architects", "Engineers", "Contractors"];

  useEffect(() => {
    const slideInterval = setInterval(() => {
      setCurrentHeroSlide((prev) => (prev + 1) % heroImages.length);
    }, 4000); // changes every 4 seconds
    return () => clearInterval(slideInterval);
  }, [heroImages.length]);

  useEffect(() => {
    if (!wordsToType || wordsToType.length === 0) return;
    const currentWord = wordsToType[typingIndex];
    if (!currentWord) return;

    let typingSpeed = isDeleting ? 50 : 120; // Deleting is faster than typing

    if (!isDeleting && charIndex === currentWord.length) {
      typingSpeed = 1500;
      setTimeout(() => setIsDeleting(true), typingSpeed);
      return;
    } else if (isDeleting && charIndex === 0) {
      setIsDeleting(false);
      setTypedText(""); // Reset
      setTypingIndex((prev) => (prev + 1) % wordsToType.length);
      return;
    }

    const timeout = setTimeout(() => {
      if (!isDeleting) {
        setTypedText(currentWord.substring(0, charIndex + 1));
        setCharIndex((prev) => prev + 1);
      } else {
        setTypedText(currentWord.substring(0, charIndex - 1));
        setCharIndex((prev) => prev - 1);
      }
    }, typingSpeed);

    return () => clearTimeout(timeout);
  }, [charIndex, isDeleting, typingIndex, wordsToType]);

  const nextHeroSlide = () => {
    setCurrentHeroSlide((prev) => (prev + 1) % heroImages.length);
  };

  const prevHeroSlide = () => {
    setCurrentHeroSlide((prev) => (prev - 1 + heroImages.length) % heroImages.length);
  };

  return (
    <section
      className="hero"
      style={{
        backgroundImage: `linear-gradient(rgba(0, 0, 0, ${overlay !== undefined ? overlay : '0.0'}), rgba(0, 0, 0, ${overlay !== undefined ? overlay : '0.0'})), url(${heroImages[currentHeroSlide]})`,
        backgroundSize: 'cover',
        backgroundPosition: 'center',
        backgroundRepeat: 'no-repeat',
        transition: 'background-image 0.8s ease-in-out'
      }}
    >
      <button className="hero-slider-btn left" onClick={prevHeroSlide}>
        <ChevronLeft size={20} />
      </button>
      <button className="hero-slider-btn right" onClick={nextHeroSlide}>
        <ChevronRight size={20} />
      </button>

      <div className="hero-content" style={contentMaxWidth ? { maxWidth: contentMaxWidth } : {}}>
        <p className="hero-subtitle">{overline || "Scan to BIM Services in USA"}</p>
        <h1>
          {title || (
            <>
              {staticTitle || (
                <>
                  Award-Winning Point Cloud Scan to <span className="text-primary">BIM Modeling</span>
                  <br />
                  <span className="text-primary">Services Company Trusted by </span>
                </>
              )}
              <span style={{ color: typingColor || '#ffffff' }}>{typedText}</span>
            </>
          )}
        </h1>
        {description && <p className="hero-description">{description}</p>}
        <button className="hero-btn">
          {buttonText || "Request Quote"} <ArrowUpRight size={18} />
        </button>
      </div>
    </section>
  );
};

export default HeroSection;
